module.exports = __webpack_public_path__ + "static/media/alutherm.fe92b836.jpg";